export default "__VITE_ASSET__ZC2xE1bV__"